import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const RecipientFilters = ({ 
  searchTerm, 
  onSearchChange, 
  selectedCountry, 
  onCountryChange, 
  selectedStatus, 
  onStatusChange,
  viewMode,
  onViewModeChange,
  onClearFilters 
}) => {
  const countryOptions = [
    { value: '', label: 'All Countries' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'Germany', label: 'Germany' },
    { value: 'France', label: 'France' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Portugal', label: 'Portugal' },
    { value: 'Ireland', label: 'Ireland' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'verified', label: 'Verified' },
    { value: 'pending', label: 'Pending' },
    { value: 'failed', label: 'Failed' }
  ];

  const hasActiveFilters = searchTerm || selectedCountry || selectedStatus;

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 lg:space-x-4">
        {/* Search and Filters */}
        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 flex-1">
          <div className="flex-1 max-w-md">
            <Input
              type="search"
              placeholder="Search recipients by name, bank, or IBAN..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="w-full"
            />
          </div>
          
          <div className="flex space-x-4">
            <Select
              placeholder="Filter by country"
              options={countryOptions}
              value={selectedCountry}
              onChange={onCountryChange}
              className="w-48"
            />
            
            <Select
              placeholder="Filter by status"
              options={statusOptions}
              value={selectedStatus}
              onChange={onStatusChange}
              className="w-48"
            />
          </div>
        </div>

        {/* View Controls */}
        <div className="flex items-center space-x-4">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              iconSize={16}
            >
              Clear Filters
            </Button>
          )}
          
          <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
            <Button
              variant={viewMode === 'cards' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('cards')}
              iconName="Grid3X3"
              iconSize={16}
            />
            <Button
              variant={viewMode === 'table' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('table')}
              iconName="List"
              iconSize={16}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipientFilters;